/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Thumbnail.css'); }
var Spinner_1 = require("./Spinner");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-thumbnail");
var Thumbnail = /** @class */ (function (_super) {
    tslib_1.__extends(Thumbnail, _super);
    function Thumbnail(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    Thumbnail.prototype.handleClick = function (e) {
        e.preventDefault();
        this.props.onClick(e);
    };
    Thumbnail.prototype.render = function () {
        var _a = this.props, className = _a.className, src = _a.src, title = _a.title, target = _a.target, rel = _a.rel, subTitle = _a.subTitle, ratio = _a.ratio;
        var ratioStyles;
        if (ratio) {
            ratioStyles = {
                paddingTop: ratio * 100 + "%"
            };
        }
        return (React.createElement("a", { href: "#", onClick: this.handleClick, target: target, rel: rel, className: classnames(moduleClassName(), "no-underline", className) },
            !src ? (React.createElement("div", { className: moduleClassName("spinner"), style: ratioStyles },
                React.createElement(Spinner_1.Spinner, null))) : (React.createElement("img", { src: src, className: moduleClassName("image") })),
            React.createElement("div", { className: moduleClassName("label") },
                React.createElement("div", { className: moduleClassName("title") }, title),
                React.createElement("div", { className: moduleClassName("subTitle") }, subTitle))));
    };
    Thumbnail.propTypes = {
        onClick: PropTypes.func.isRequired,
        className: PropTypes.string,
        src: PropTypes.string,
        title: PropTypes.string,
        subTitle: PropTypes.string,
        target: PropTypes.string,
        rel: PropTypes.string,
        ratio: PropTypes.number
    };
    return Thumbnail;
}(React.Component));
exports.Thumbnail = Thumbnail;